import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
export function useResultCategoryOutletContext(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.sideImage, sideImage = _c === void 0 ? '' : _c, _d = _b.step, step = _d === void 0 ? 0 : _d;
    var _e = useOutletContext(), setImage = _e.setImage, setStep = _e.setStep;
    useEffect(function () {
        if (sideImage)
            setImage(sideImage);
        if (step)
            setStep(step);
        return function () {
            setImage('');
            setStep(0);
        };
    }, []);
    return { setImage: setImage, setStep: setStep };
}
